import { getAmplitudeInstance } from '../amplitudeHelpers';
import WaypointCategoryValue from '../enums/WaypointCategoryValue';
import WaypointEditType from '../enums/WaypointEditType';
import WaypointEntryPoint from '../enums/WaypointEntryPoint';
import WaypointSourceKindValue from '../enums/WaypointSourceKindValue';

type logWaypointEditStartedParams = {
  category?: WaypointCategoryValue;
  edit_type: WaypointEditType;
  entry_point: WaypointEntryPoint;
  source_kind?: WaypointSourceKindValue;
  waypoint_id?: number;
};

/**
 * User enters waypoint edit mode, either for a new waypoint (add flow) or an existing waypoint (edit button).
 * @param params - Attributes to log with the amplitude event
 * @param params.category - The category of the waypoint being edited.
 * @param params.edit_type - Whether the user is creating a new waypoint (add_new) or editing an existing one (edit_existing).
 * @param params.entry_point - The surface from which edit mode was entered.
 * @param params.source_kind - The origin of the waypoint (route-specific or user global).
 * @param params.waypoint_id - The remote server ID of the waypoint, if synced. Null for new waypoints.
 */
const logWaypointEditStarted = (
  { category, edit_type, entry_point, source_kind, waypoint_id }: logWaypointEditStartedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'waypoint edit started',
    { category, 'edit type': edit_type, 'entry point': entry_point, 'source kind': source_kind, 'waypoint id': waypoint_id },
    callback
  );
};

export default logWaypointEditStarted;
